/**
* 顶部菜单
*/
<template>
  <div>
    <!-- Home顶部功能区域 -->
    <div class="site-nav" id="site-nav">
      <div class="w w1200">
        <ul class="quick-menu fl">
          <!-- <li>
            <div class="dt">
              <a href="#">品牌馆</a>
            </div>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <a href="/#/welcomesystem">商家入驻</a>
            </div>
          </li> -->
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <a href="javascript:;"><i class="el-icon-phone"></i> HELLO:400-888-2815</a>
            </div>
          </li>
          <li class="spacer"></li>
          <li class="li_dorpdown">
            <div class="dt">
              <a
                href="javascript:;"
                @mouseenter="showapp = !showapp"
                @mouseleave="showapp = !showapp"
                ><i class="el-icon-mobile-phone"></i> APP下载
                <i class="el-icon-arrow-down"></i
              ></a>
            </div>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div
                v-show="showapp"
                class="dropdown-menu"
                style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #ff6700;
                "
              >
                <el-image
                  :src="appimg"
                  fit="fill"
                  style="width: 160px; height: 160px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </transition>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <a
                href="javascript:;"
                @mouseenter="showwx = !showwx"
                @mouseleave="showwx = !showwx"
                ><i class="el-icon-mobile-phone"></i> 微商城
                <i class="el-icon-arrow-down"></i
              ></a>
            </div>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div
                v-show="showwx"
                class="dropdown-menu"
                style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #ff6700;
                "
              >
                <el-image
                  :src="appimg"
                  fit="fill"
                  style="width: 160px; height: 160px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </transition>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="amap-page-container">
              <el-amap
                vid="amap"
                :plugin="plugin"
                class="amap-demo"
                :center="center"
              >
              </el-amap>
              <div class="toolbar">
                <span
                  v-if="loaded"
                  style="color: rgb(102, 102, 102); border-radius: 4px"
                >
                  <i class="el-icon-location"></i> {{ city }}
                </span>
                <span v-else>正在定位</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="fl">
          <div class="city-choice" id="city-choice" data-ectype="dorpdown">
            <div class="dsc-choie dsc-cm" ectype="dsc-choie">
              <img src="images/place.png" class="place" />
              <input type="text" value="全国" class="search" />
            </div>
          </div>
        </div>
        <ul class="quick-menu fr">
          <li>
            <div class="dt">
              <!-- <a href="/login" v-if="userInfo.loginName==null?true:false">登录</a> -->
              <router-link to="/login" v-if="userInfo.loginName==null?true:false">登录</router-link>
              <!-- <a  v-if="userInfo.userName==null?false:true">{{userInfo.userName}}</a> -->
            </div>
            <el-dropdown>
                <span class=" el-dropdown-link" style="cursor:pointer"> <a  v-if="userInfo.loginName==null?false:true">{{userInfo.userName}}</a></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><a href="javaScript:;" @click="rollOut">退出</a></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </li>
          <li v-if="userInfo.loginName==null?true:false" class="spacer"></li>
          <li>
            <div class="dt">
              <!-- <a href="/register"  v-if="userInfo.loginName==null?true:false">注册</a> -->
              <router-link to="/register" v-if="userInfo.loginName==null?true:false">注册</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <!-- <a href="/myOrder">我的订单</a> -->
              <router-link to="/myOrder">我的订单</router-link>
              <!-- <a href="#/myOrder_supplier">我的订单</a> -->
            </div>
          </li>
          <li class="spacer"></li>
          <!-- <li>
            <div class="dt">
              <a href="#">我的浏览</a>
            </div>
          </li>
          <li class="spacer"></li> -->
          <li>
            <div class="dt">
              <!-- <a href="#">我的收藏</a> -->
              <router-link to="/goodsCollection">我的收藏</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <li>
            <!-- <div class="dt">
              <a href="#">客户服务</a>
            </div> -->
            <el-dropdown>
              <span class="dt el-dropdown-link" style="cursor:pointer"> 客户服务</span>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><router-link to="/siteHelp?articleId=2&categoryId=8">帮助中心</router-link></el-dropdown-item>
                  <el-dropdown-item><router-link to="/siteHelp?articleId=5&categoryId=5">售后服务</router-link></el-dropdown-item>
                  <el-dropdown-item><router-link to="/siteHelp?articleId=6&categoryId=4">客户中心</router-link></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="spacer"></li>
          <li>
            <el-dropdown>
                <span class="dt el-dropdown-link" style="cursor:pointer"> 站点导航</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><router-link to="/siteNavigation">用户中心</router-link></el-dropdown-item>
                  <el-dropdown-item><router-link to="/paymentCenter">支付中心</router-link></el-dropdown-item>
                  <el-dropdown-item><router-link to="/">网站首页</router-link></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            <!-- <div
              class="dt dsc-cm"
              @mouseenter="show2 = !show2"
              @mouseleave="show2 = !show2"
            >
              网站导航
            </div> -->
            <!-- 隐藏区域 -->
            <!-- <el-collapse-transition>
              <div
                v-show="show2"
                class="dd dorpdown-layer"
                style="z-index: 10000000"
              >
                <dl class="fore1">
                  <dt>特色主题</dt>
                  <dd>
                    <div class="item">
                      <a href="#">家用电器</a>
                    </div>
                    <div class="item">
                      <a href="#">手机数码</a>
                    </div>
                    <div class="item">
                      <a href="#">电脑办公</a>
                    </div>
                  </dd>
                </dl>
                <dl class="fore2">
                  <dt>促销活动</dt>
                  <dd>
                    <div class="item">
                      <a href="#">拍卖活动</a>
                    </div>
                    <div class="item">
                      <a href="#">共创商品</a>
                    </div>
                    <div class="item">
                      <a href="#">优惠活动</a>
                    </div>
                    <div class="item">
                      <a href="#">批发市场</a>
                    </div>
                    <div class="item">
                      <a href="#">超值礼包</a>
                    </div>
                    <div class="item">
                      <a href="#">优惠券</a>
                    </div>
                  </dd>
                </dl>
              </div>
            </el-collapse-transition> -->
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
              <!-- 0:没有批发市场 1:批发市场 -->
              <!-- <a href="https://xunyoushop.com">商家中心</a> -->
              <!-- <a to="http://xunyoushop.com">商家中心</a> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- logo+收索 -->
    <div class="w w1200">
      <el-row class="logotop" type="flex" justify="center" align="top">
        <el-col :span="8">
          <div class="fl">
            <el-image @click="$router.push('/')" class="logo" style="cursor:pointer" :src="logo" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <el-image
              :src="require('@/assets/images/ecsc-join.gif')"
              fit="fill"
              style="border-radius: 5px"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-input
              :placeholder="hotSearchList[0]"
              v-model="searchInput"
              class="input-with-select"
              style="border: 1px solid #e13c41; border-radius: 4px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                style="font-size: 22px"
                @click="getSearchClick"
              ></el-button>
            </el-input>
          </div>
          <div style="margin-top: 5px; text-align: left">
            <span v-for="(item,index) in hotSearchList" :key="index">
              <!-- <router-link :to="`/goodsList_supplier?adWord=${item}`">{{item}}</router-link> -->
              <router-link :to="`/goodsList_supplier?adWord=${item}`">{{item}}</router-link>
              <el-divider direction="vertical"></el-divider>
            </span>
          </div>
        </el-col>
        <el-col :span="6" style="text-align: right">
          <div class="grid-content bg-purple">
            <el-popover placement="top-start" width="400" trigger="click">
               <div class="cartTip" v-loading='loading'>
                  <el-row :gutter="20" class="cartBox" v-for="(item,index) in list" :key="index">
                    <el-col :span="5"><el-image class="cartgoodsPhotos" :src="`${item.photos}`"></el-image></el-col>
                    <el-col :span="12"><div class="cartHeight" title="">{{item.name}}</div></el-col>
                    <!-- marketprice 需要乘以折扣 -->
                    <el-col :span="6"><div class="cartHeight">{{item.realprice}} * {{item.number}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" v-if="totalNumber==0?true:false">购物车还没有商品,赶紧选购吧!</el-col>
                </el-row>
                <el-row  class="cartBox_footer">
                    <el-col :span="12"><div class="cartHeight_total"><p class="totalNum">共 {{totalNumber}} 件商品</p><p>{{accountTotal.toFixed(2)||0}} 元</p></div></el-col>
                    <el-col :span="12"><div class="cartHeight_cart"><router-link to="/shoppingcart" style="color:white">去购物车结算</router-link></div></el-col>
                    <!-- <el-col :span="12"><div class="cartHeight_cart"><router-link to="/shoppingcart_supplie" style="color:white">去购物车结算</router-link></div></el-col> -->
                </el-row>
              </div>
                <!-- <el-button slot="reference" class="shopgoods" @click="$router.push('/shoppingcart_supplie')"> -->
                <el-button slot="reference" class="shopgoods" >
                <i class="el-icon-shopping-cart-full"></i> 购物车 ({{
                    totalNumber
                  }})
                </el-button>
            </el-popover>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 顶部菜单 -->
    <div class="w w1200" v-if="isShowNav">
      <div class="categorys">
        <div class="categorys-type"  @mouseenter="mouseenterBox" @mouseleave="mouseLeaveBox">
          <a href="javascript:;"
            ><i class="el-icon-menu"></i> 全部商品分类</a
          >
        </div>
        <!-- 隐藏分类 -->
        <div class="categorys-tab-content" v-show="isShowCategoryList"  @mouseleave="mouseLeaveBox">
          <div class="categorys-items" id="cata-nav">
            <!-- 商品分类start -->
            <div
              class="categorys-item"
              v-for="(oneItem,index) in categoryList"
              :key="index + '_item'"

            >
              <!-- <div class="item item-content"  v-if="oneItem.subItems.length>0?true:false"> -->
              <div class="item item-content">
                <i class="iconfont icon-ele"
                  ><img :src="require('../assets/images/icon/elece.png')" style="vertical-align: baseline;"
                /></i>
                <div class="categorys-title">
                  <strong>
                    <router-link :to="`/goodsList_supplier?parentBxscId=${oneItem.categoryOne.bxscId}`"
                      >{{oneItem.categoryOne.name}}</router-link
                    >
                  </strong>
                  <span>
                    <router-link
                      :to="`/goodsList_supplier?parentBxscId=${subItems.category.bxscId}`"

                      v-for="(subItems,index) in oneItem.subItems.slice(0,2)"
                      :key="index+'_sub'"

                      ><template>{{subItems.category.name}}</template></router-link
                    >
                  </span>
                </div>
              </div>
              <div class="categorys-items-layer">
                <div class="cate-layer-con clearfix">
                  <div class="cate-layer-left">
                    <div class="cate_channel">
                      <router-link :to="`/goodsList_supplier?parentBxscId=${subItem.category.bxscId}`" v-for="(subItem,index) in oneItem.subItems.slice(0,6)" :key="index+'sunItem'">{{subItem.category.name}}</router-link>
                      <!-- <a href="#">家电城</a>
                      <a href="#">智能生活馆</a>
                      <a href="#">京东净化馆</a>
                      <a href="#">补充</a>
                      <a href="#">值得买精选</a> -->
                    </div>
                    <div class="cate_detail">
                      <dl
                        v-for="(subItem,index) in oneItem.subItems"
                        :key="index+'sunItem'"
                        :class="'dl_fore'+(index+1)"
                      >
                        <dt>
                          <router-link :to="`/goodsList_supplier?parentBxscId=${subItem.category.bxscId}`"
                            >{{subItem.category.name}}</router-link
                          >
                        </dt>
                        <dd>
                          <router-link
                            :to="`/goodsList_supplier?parentBxscId=${thrItem.bxscId}`"

                            v-for="(thrItem,index) in subItem.sub"
                            :key="index+'_thr'"
                            >{{thrItem.name}}</router-link
                          >
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div v-if='oneItem.subItems.length==0?true:false' class="nodataCss">
                      <p>暂无相关分类数据</p>
                  </div>
                  <!-- <div class="cate-layer-rihgt">
                    <h3>热门推荐</h3>
                    <div class="cate-layer-right-slide">
                      <img th:src="@{/portal/images/elec1.jpg}" />
                    </div>
                    <div class="cate-layer-right-slide">
                      <img th:src="@{/portal/images/elec1.jpg}" />
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-main">
        <!-- <a href=""><i class="fa fa-bars"></i> 全部商品分类</a> -->
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
         :router="true"
          @select="handleSelect"
        >
          <!-- navUrl -->
          <el-menu-item
            v-for="(item, index) in navList"
            :key="index + '_nav'"
            :index="item.navUrl"
          >
            {{ item.navTitle }}
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
import { menu } from "../api/userMG";
import mainlayout from "../components/layout/mainlayout";
import { navList,leftMenuList,shoppingCartlist,hot_search,search_list,setImage} from "@/api/xunyou";
import {mapState,mapMutations, mapGetters} from 'vuex'
export default {
  name: "leftnavs",
  inject:['reload'],
  data() {
    let self = this;
    return {
      loading:false,
      userInfo: this.$store.state.userInfo,
      // input: "",
      // goodsnum: 0,
      // accountTotal:0,
      showapp: false, //app不显示
      appimg:
        "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200806/1596701627449534.png",
      showwx: false, //微信不显示
      show2: false, //默认进入不显示
      collapsed: false,
      allmenu: [],
      // list:[], //购物车的数据
      //地图
      center: [121.59996, 31.197646],
      city: "全国",
      lng: 0,
      lat: 0,
      loaded: false,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  console.log(result, "|wb");
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.city = result.addressComponent.city||result.addressComponent.district;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            },
          },
        },
      ],
      navList: [
        {
                id:1,
                navTitle:'店铺馆',
                navUrl:'/store_supplier',
            },
            {
                id:2,
                navTitle:'商品列表',
                navUrl:'/goodsList_supplier'
            },
            // {
            //     id:3,
            //     navTitle:'联系我们',
            //     navUrl:'/contactUs'
            // },
            {
                id:3,
                navTitle:'商城首页',
                navUrl:'/'
            }
      ],

      activeIndex: "1",
      categoryList:[],
      hotSearchList:[],
      searchInput:'',
      isShowCategoryList:false,
      logo:''
    };
  },
  // 注册组件
  components: {
    mainlayout,
  },
  computed:{
    ...mapState(['isShowNav','list','accountTotal','totalNumber']),
  },
   // 创建完毕状态(里面是操作)
  created() {
    // this.searchNavList();
    this.searchleftMenuList();
  },
   // 挂载结束状态(里面是操作)
  mounted() {
    // if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
    //     this.getshoppingCartlist();
    // }
    // this.getSearchList() // pc端不需要该接口，属于手机端
    this.gethotSearch()
    this.getImagelogo()
  },

  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
     getSearchClick(){
      if(this.searchInput==''){
        this.$router.push(`/goodsList_supplier?adWord=${this.hotSearchList[0]}`)
        this.searchInput = this.hotSearchList[0]
      }else{
        this.$router.push(`/goodsList_supplier?adWord=${this.searchInput}`)
      }
    },

        // 获取logo
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            this.logo = res.rows[0].pcLogo
          }
        })
    },
    // 鼠标移入移出
    mouseenterBox(){
       if(this.$route.path=='/supplierIndex'){
         this.isShowCategoryList = !this.isShowCategoryList
         }else{
        this.isShowCategoryList = false
      }
      // this.isShowCategoryList = !this.isShowCategoryList
    },
     // 鼠标移入移出
    mouseLeaveBox(){
       if(this.$route.path=='/supplierIndex'){
         this.isShowCategoryList = !this.isShowCategoryList
         }else{
        this.isShowCategoryList = false
      }
    },
     // 退出登录
    rollOut(){
      localStorage.removeItem('userdata');
      this.$router.push('/login')
    },

    // // 购物车查询
    // getshoppingCartlist() {
    //    this.accountTotal =0
    //    this.loading = true
    //   shoppingCartlist({uid:this.userInfo.userId||''})
    //     .then((res) => {
    //       this.loading = false
    //      let newList= []
    //       res.forEach((x)=>{
    //           x.bxunyouMerchant.goods.forEach((y)=>{
    //             newList.push(y)
    //           })
    //       })
    //         this.list = newList;
    //         let sum = this.list.reduce((sum, item) => {
    //                   return sum + item.realprice * item.number; // 隐式转换
    //               }, 0);
    //               this.accountTotal += sum;
    //         })
    //     .catch((err) => {
    //       // this.$message.error("查询购物车失败，请稍后再试！");
    //     });
    // },

    // 菜单
    searchNavList() {
      this.loading = true;
      navList()
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.navList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 左侧菜单
    searchleftMenuList() {
      this.loading = true;
      leftMenuList()
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.categoryList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    handleSelect(key, keyPath) {
      if(this.$route.path==key){
         this.reload()
      }
    },

       // 热门搜索
    gethotSearch() {
      hot_search()
        .then((res) => {
          if (res.code == 0) {
            this.hotSearchList = res.data.column10.split(',');
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
     // 默认搜索
    getSearchList() {
      search_list()
        .then((res) => {
          if (res.code == 0) {
            this.searchInput = res.rows[0].column1;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
  },


};
</script>
<style lang="less" scoped>
/deep/ .logo img{
  width: 255px;
  height: 52px;
}
.logotop {
  margin: 1rem 0;
}
.el-input-group__append {
  border-left: 0;
  background-color: #e13c41;
}
.el-input-group__append,
.el-input-group__prepend {
  background-color: #e13c41;
  color: white;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 0px;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
/* 购物车样式 */
button.el-button.shopgoods.el-button--default.el-popover__reference:hover {
  border: 1px solid #e13c41;
  color: #e13c41;
  background: #fff;
}

/* top菜单 */
.categorys {
  float: left;
  width: 232px;
  height: 40px;
  position: relative;
}

.categorys-type {
  background-color: var(--main-theme-color);
  text-align: center;
  font-size: 0;
  line-height: 40px;
}

.categorys-type a {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  display: block;
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

/* 分类表 */
.categorys-tab-content {
  height: auto !important;
  padding: 15px 0;
	z-index: 30;
	background-color: #000;
	background-color: rgba(0, 0, 0, 0.6);
	/* bingo */
  display:block;
  position: relative;
}

.categorys-tab-content .categorys-items {
	position: relative;
	height: 100%;
}

.categorys-tab-content .categorys-item {
	cursor: pointer;
	height: 14.29%;
}

.categorys-tab-content .item-content {
	padding: 5px 16px;
	float: left;
	width: 200px;
}

.categorys-tab-content .item-content .icon-other {
	float: left;
	width: 18px;
	height: 18px;
}

.categorys-tab-content .item-content .icon-other img {
	width: 100%;
}

.categorys-tab-content .selected .item-content {
	background-color: rgba(0, 0, 0, 1);
}

.categorys-tab-content .iconfont {
	float: left;
	color: #bfbfbf;
}

.categorys-tab-content .categorys-title {
	float: left;
  margin-left: 10px;
      text-align: left;
}

.categorys-tab-content .categorys-title strong {
	display: block;
	font-weight: normal;
}

.categorys-tab-content .categorys-title strong a {
	color: #fff;
	font-size: 14px;
}

.categorys-tab-content .categorys-title span {
	display: block;
	font-size: 0;
}

.categorys-tab-content .categorys-title span a {
	color: #bfbfbf;
	margin-right: 10px;
	font-size: 14px;
}

.categorys-tab-content .categorys-title span a:hover,
.categorys-tab-content .categorys-title strong a:hover {
	color: #e23435;
}

.categorys-items-layer {
	display: none;
	position: absolute;
	top: 0;
	left: 232px;
	width: 966px;
	min-height: 498px;
	border: 1px solid #fff;
	background-color: #fff;
	box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, .1);
	-webkit-transition: top .25s ease;
  transition: top .25s ease;
  .nodataCss {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }
}

/* 购物车的样式 */
.cartTip{
  .cartBox.el-row {
      margin: 15px;
      // background: red;
      height: 80px;
     .el-image.cartgoodsPhotos {
          height: 80px;
          width: 100%;
          position: inherit;
      }
      .cartHeight {
          height: 80px;
          line-height: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
      }

  }
  .cartHeight_total {
      font-size: 18px;
      padding: 0 20px;
      color: #ff6700;
      .totalNum{
          font-size: 14px;
          color: #000;
      }
  }
  .cartHeight_cart {
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #ff6700;
      color: white;
      font-size: 15px;
      a.router-link-exact-active.router-link-active {
          color: white;
      }
    }

}

</style>



// WEBPACK FOOTER //
// src/components_supplier/topnav.vue